import React, { Component } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import SkinAnalysisIcons from './SkinAnalysisIcons';
import darkcircles from '../../images/instore/icons/dark-circles.svg';
import eyebags from '../../images/instore/icons/eyebags.svg';
import eyecolor from '../../images/instore/icons/eyecolor.svg';
import pigmentvariation from '../../images/instore/icons/pigment-variation.svg';
import radiance from '../../images/instore/icons/radiance.svg';
import shape from '../../images/instore/icons/shape.svg';
import undertone from '../../images/instore/icons/undertone.svg';
import wrinkleslines from '../../images/instore/icons/wrinkles-lines.svg';
import warning from '../../images/instore/icons/warning-icon.svg';
import acne from '../../images/instore/icons/acne.svg';
import skinShine from '../../images/instore/icons/skin-shine.svg';
import redness from '../../images/instore/icons/redness.svg';
import texture from '../../images/instore/icons/texture.svg';
import { translate } from 'react-polyglot';

const Item = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: space-between;
  position: relative;
  order: ${props => (props.order ? props.order : 100)};
  width: 100px;
  height: 100px;
  color: ${props => (props.selected ? props.rangeColor || '#00FF89' : 'white')};

  .value,
  .label {
    text-align: center;
    font-size: 12px;
    font-weight: 600;
  }
  .rangeColor {
    width: 60%;
    height: 6px;
    margin: auto;
    background-color: ${props => props.rangeColor};
  }
  .icon {
    height: 48px;
    width: 48px;
    margin: 2px auto;
    fill: tomato;
  }
  .iconSkintoneColor {
    height: 38px;
    width: 38px;
    margin: 2px auto;
    border-radius: 20px;
    margin: 6px auto;
  }
  .darkcircles {
    background-image: url(${darkcircles});
  }
  .eyebags {
    background-image: url(${eyebags});
  }
  .eyecolor {
    background-image: url(${eyecolor});
  }
  .pigmentvariation {
    background-image: url(${pigmentvariation});
  }
  .radiance {
    background-image: url(${radiance});
  }
  .shape {
    background-image: url(${shape});
  }
  .undertone {
    background-image: url(${undertone});
  }
  .wrinkleslines {
    background-image: url(${wrinkleslines});
  }
  .acne {
    background-image: url(${acne});
  }
  .skinShine {
    background-image: url(${skinShine});
  }
  .texture {
    background-image: url(${texture});
  }
  .redness {
    background-image: url(${redness});
  }
  .warning {
    background-image: url(${warning});
    position: absolute;
    width: 16px;
    height: 16px;
    right: 24px;
    top: 28px;
  }
  .tooltip {
    position: absolute;
    left: 0;
    top: -150px;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 8px;
    width: 300px;
    height: 120px;
    padding: 20px;
    color: white;
    line-height: 1.4;
    transform: translate3d(0, 20px, 0);
    opacity: 0;
    transition: transform 0.5s cubic-bezier(0.5, 0, 0, 1.2);
    ul {
      list-style: none;
      overflow-y: scroll;
      max-height: 80px;
      margin-bottom: 10px;
      z-index: 1;
      li {
        margin-bottom: 10px;
      }
      &::-webkit-scrollbar {
        display: none;
      }
    }
    &:after {
      position: absolute;
      content: '';
      width: 100%;
      height: 50%;
      background: linear-gradient(to top, rgba(0, 0, 0, 1), rgba(0, 0, 0, 0.1));
      bottom: 0;
      left: 0;
      border-bottom-left-radius: 8px;
      border-bottom-right-radius: 8px;
      z-index: 2;
    }
    &:before {
      position: absolute;
      content: '';
      bottom: -10px;
      left: 40px;
      height: 10px;
      width: 20px;
      background: linear-gradient(-135deg, rgba(0, 0, 0, 1) 50%, transparent 50%),
        linear-gradient(135deg, rgba(0, 0, 0, 1) 50%, transparent 50%);
      background-position: 0 0, 10px 0;
      background-repeat: no-repeat no-repeat;
      background-size: 10px 10px, 10px 10px;
    }
  }
  .tooltipActive {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
`;

class SkinAnalysisItem extends Component {
  render = () => {
    const { icon, label, value, rangeColor, selected, onClick, order, warnings, t } = this.props;
    return (
      <Item selected={selected} onClick={onClick} order={order} rangeColor={rangeColor}>
        {rangeColor && <div className="rangeColor"> &nbsp; </div>}
        <div className="value">{value}</div>
        {icon === 'skintoneColor' && <div className={'iconSkintoneColor'} style={{ backgroundColor: value }}></div>}
        {icon !== 'skintoneColor' && <div className={'icon ' + icon}></div>}
        <div className="label">{t(label)}</div>
        {warnings ? <div className="warning"></div> : null}
        {warnings ? (
          <div className={selected ? 'tooltip tooltipActive' : 'tooltip'}>
            <ul>
              {warnings.map((warning, i) => {
                return <li key={i}>{t('CV_CODE_' + warning.idx)}</li>;
              })}
            </ul>
          </div>
        ) : null}
      </Item>
    );
  };
}

SkinAnalysisItem.propTypes = {
  icon: PropTypes.oneOf(Object.keys(SkinAnalysisIcons)),
  label: PropTypes.string,
  value: PropTypes.string,
  selected: PropTypes.bool,
  warnings: PropTypes.array,
};

export default translate()(SkinAnalysisItem);



// WEBPACK FOOTER //
// ./src/components/instore/SkinAnalysisItem.js